/* XPOWER - Barra de "te falta X para el envio gratis".
   El umbral debe coincidir con el de Configuracion > Envios. */
(function(){
  var UMBRAL = 15000000;   /* $150.000 en centavos */

  var CAMION = '<svg class="xp-env__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="14" height="12" rx="1.5"></rect><path d="M15 8h4l3 3v5h-7z"></path><circle cx="6" cy="19" r="2"></circle><circle cx="18" cy="19" r="2"></circle></svg>';

  /* Sin expresiones regulares: agrupa los miles con punto, como se escribe en Colombia */
  function pesos(centavos){
    var v = Math.round(centavos / 100).toString();
    var out = '', k = 0;
    for(var i = v.length - 1; i >= 0; i--){
      out = v.charAt(i) + out;
      k++;
      if(k % 3 === 0 && i > 0){ out = '.' + out; }
    }
    return '$' + out;
  }

  function caja(){
    var d = document.createElement('div');
    d.className = 'xp-env';
    d.setAttribute('data-xp-env-caja', '1');
    d.innerHTML = '<p class="xp-env__t"></p><div class="xp-env__pista"><span class="xp-env__barra"></span></div><p class="xp-env__pie"></p>';
    return d;
  }

  function donde(){
    var puntos = [];
    [].forEach.call(document.querySelectorAll('[data-xp-envio]'), function(e){ puntos.push(e); });

    var cuerpo = document.body;

    if(cuerpo.className.indexOf('template-cart') >= 0){
      var f = document.querySelector('form[action*="/cart"]') || document.querySelector('.main-content .container') || document.querySelector('.main-content');
      if(f && !f.querySelector('[data-xp-env-caja]')){
        var c1 = caja();
        f.insertBefore(c1, f.firstChild);
        puntos.push(c1);
      }
    }

    if(cuerpo.className.indexOf('template-product') >= 0){
      var cta = document.querySelector('.xp-cta');
      if(cta && cta.parentNode && !cta.parentNode.querySelector('[data-xp-env-caja]')){
        var c2 = caja();
        if(cta.nextSibling){ cta.parentNode.insertBefore(c2, cta.nextSibling); }
        else { cta.parentNode.appendChild(c2); }
        puntos.push(c2);
      }
    }

    return puntos.map(function(p){
      if(p.hasAttribute('data-xp-env-caja')) return p;
      if(!p.querySelector('[data-xp-env-caja]')){ p.appendChild(caja()); }
      return p.querySelector('[data-xp-env-caja]');
    });
  }

  function pinta(total){
    var cajas = donde();
    if(!cajas.length) return;
    var falta = UMBRAL - total;
    var pct = Math.max(0, Math.min(100, (total / UMBRAL) * 100));

    cajas.forEach(function(c){
      var t = c.querySelector('.xp-env__t');
      var b = c.querySelector('.xp-env__barra');
      var p = c.querySelector('.xp-env__pie');

      if(total <= 0){
        c.classList.remove('xp-env--listo');
        t.innerHTML = CAMION + '<span>Envio gratis en compras desde <b>' + pesos(UMBRAL) + '</b></span>';
        p.textContent = 'Despachamos en 24 horas habiles a todo el pais.';
      } else if(falta > 0){
        c.classList.remove('xp-env--listo');
        t.innerHTML = CAMION + '<span>Te faltan <b>' + pesos(falta) + '</b> para el envio gratis</span>';
        p.textContent = 'Agrega una prenda mas y no pagas envio.';
      } else {
        c.classList.add('xp-env--listo');
        t.innerHTML = CAMION + '<span>Listo: tu pedido tiene <b>envio gratis</b></span>';
        p.textContent = 'Despachamos en 24 horas habiles a todo el pais.';
      }
      b.style.width = pct.toFixed(1) + '%';
    });
  }

  function revisa(){
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(c){ pinta(c.total_price); })
      .catch(function(){});
  }

  /* Cuando el tema agrega o cambia algo en el carrito, volvemos a mirar */
  function espia(){
    var fOrig = window.fetch;
    if(fOrig){
      window.fetch = function(){
        var u = arguments[0];
        var url = (typeof u === 'string') ? u : (u && u.url) || '';
        var p = fOrig.apply(this, arguments);
        if(url.indexOf('/cart/') >= 0){
          try{ p.then(function(){ setTimeout(revisa, 400); }).catch(function(){}); }catch(e){}
        }
        return p;
      };
    }
    var abrir = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(m, u){
      try{
        this.addEventListener('load', function(){
          if(String(u).indexOf('/cart/') >= 0){ setTimeout(revisa, 400); }
        });
      }catch(e){}
      return abrir.apply(this, arguments);
    };

    /* Red de seguridad: cualquier clic en un boton de compra */
    document.addEventListener('click', function(ev){
      var b = ev.target.closest ? ev.target.closest('button, input[type=submit], .btn') : null;
      if(!b) return;
      var n = (b.getAttribute('name') || '') + ' ' + (b.className || '');
      if(n.indexOf('add') >= 0 || n.indexOf('xp-cta') >= 0 || n.indexOf('xp-bar__cta') >= 0){
        setTimeout(revisa, 900);
        setTimeout(revisa, 2200);
      }
    }, true);

    window.addEventListener('pageshow', revisa);
  }

  function arranca(){ espia(); revisa(); setTimeout(revisa, 1600); }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', arranca); }
  else { arranca(); }
})();